import React from "react";

const PolicyLayout = ({ title, paragraphs }) => (
  <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50 py-10 px-4">
    <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-xl p-6 md:p-10">
      <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">{title}</h1>
      <div className="space-y-4 text-gray-700 leading-relaxed text-sm md:text-base">
        {paragraphs.map((paragraph, index) => (
          <p key={`${title}-${index}`}>{paragraph}</p>
        ))}
      </div>
    </div>
  </div>
);

const termsAndConditionsParagraphs = [
`This document contains the terms and conditions governing the use of Edumate, an AI-powered learning platform developed and operated by Patliputra Educational Toys.`,

`This document is an electronic record in terms of the Information Technology Act, 2000 and the applicable rules thereunder. This electronic record is generated by a computer system and does not require any physical or digital signatures.`,

`This document is published in accordance with Rule 3(1) of the Information Technology (Intermediaries Guidelines and Digital Media Ethics Code) Rules, 2021 that require publishing the rules and regulations, privacy policy and terms of use for access or usage of the website https://edumate.shiyaai.com and related services (hereinafter referred to as the "Platform").`,

`The Platform is owned and operated by Patliputra Educational Toys, having its registered office at Shivpur, Tikiya Toli, Musallahpur Hatt, Patna, Bihar, India (hereinafter referred to as "Company", "we", "us", or "our"). Edumate is an AI-powered educational platform designed to assist students with learning, content generation, quizzes, and academic support.`,

`By accessing or using the Platform, you agree to be bound by these Terms of Use. If you do not agree with any part of these terms, you should discontinue use of the Platform.`,

`The Platform provides AI-powered educational tools including but not limited to AI tutoring, quiz evaluation, study assistance, learning resources, and other digital learning services. These services are provided solely for educational support and informational purposes.`,

`Users agree to provide accurate and complete information during registration and to maintain the confidentiality of their account credentials. Users are responsible for all activities conducted through their accounts.`,

`The content, design, layout, graphics, AI-generated responses, and learning materials available on the Platform are the intellectual property of Patliputra Educational Toys or its licensors. Unauthorized reproduction, redistribution, or commercial use of any material from the Platform is prohibited.`,

`While the Platform utilizes artificial intelligence to assist in learning, we do not guarantee absolute accuracy, completeness, or reliability of AI-generated responses. Users are encouraged to verify important information independently.`,

`Users agree not to misuse the Platform or use it for any unlawful, harmful, or prohibited activities under applicable Indian laws.`,

`The Company reserves the right to modify, suspend, or discontinue any part of the Platform or services at any time without prior notice.`,

`Users agree to pay any applicable subscription or service fees associated with accessing premium features of the Platform.`,

`The Platform may contain links to third-party services or educational resources. We are not responsible for the content or policies of such third-party platforms.`,

`You agree to indemnify and hold harmless Patliputra Educational Toys and its employees, directors, and affiliates from any claims, damages, or liabilities arising from misuse of the Platform or violation of these Terms.`,

`These Terms shall be governed by and interpreted in accordance with the laws of India.`,

`Any disputes arising out of the use of the Platform shall be subject to the exclusive jurisdiction of the courts located in Patna, Bihar.`,

`For any queries or concerns regarding these Terms, users may contact us through the contact details provided on the Platform.`
];

const refundPolicyParagraphs = [
`This Refund and Cancellation Policy describes how refunds and cancellations are handled for subscriptions or services purchased on the Edumate platform.`,

`Edumate provides digital learning services powered by artificial intelligence. Since these services are delivered instantly upon activation, refunds may be limited once the service has been accessed.`,

`Users may request cancellation of a subscription within 7 days of purchase provided the service has not been substantially used.`,

`If a technical issue or service malfunction prevents proper access to the Platform, users may contact our support team to request assistance or a possible refund.`,

`Refund requests will be evaluated on a case-by-case basis and may be approved at the sole discretion of Patliputra Educational Toys.`,

`Approved refunds will be credited to the original payment method within 7 business days.`,

`For refund-related queries, users may contact the support team through the contact information available on the Platform.`
];

const privacyPolicyParagraphs = [
`This Privacy Policy describes how Edumate, an AI-powered learning platform developed by Patliputra Educational Toys, collects, uses, and protects user information.`,

`By using the Platform, you consent to the collection and use of information in accordance with this Privacy Policy.`,

`We may collect personal information such as your name, email address, phone number, educational preferences, and other information required to provide our services.`,

`We may also collect usage data including interactions with AI tools, learning activity, platform usage patterns, and device information to improve our services.`,

`Your information is used to provide and improve the Platform, personalize learning experiences, respond to user inquiries, process subscriptions, and ensure platform security.`,

`We do not sell or rent your personal information to third parties. However, information may be shared with trusted service providers who assist in operating the Platform.`,

`We implement reasonable technical and organizational security measures to protect user data from unauthorized access, misuse, or disclosure.`,

`Users may request access, correction, or deletion of their personal information by contacting us through the support channels provided on the Platform.`,

`We may update this Privacy Policy from time to time. Continued use of the Platform after changes indicates acceptance of the updated policy.`,

`This Privacy Policy shall be governed by the laws of India.`
];

export const TermsAndConditionsPage = () => (
  <PolicyLayout title="Terms and Conditions" paragraphs={termsAndConditionsParagraphs} />
);

export const PrivacyPolicyPage = () => (
  <PolicyLayout title="Privacy Policy" paragraphs={privacyPolicyParagraphs} />
);

export const RefundPolicyPage = () => (
  <PolicyLayout title="Refund Policy" paragraphs={refundPolicyParagraphs} />
);

